//Imports de components presents dans la page about
import React from "react";
import Topnav from "../components/Topnav.js";
import Footer from "../components/Footer.js";
import ListeDeProjets from "../components/ListeDeProjets.js";


//Création du composant
const Projets = () => {
    //Backend
    //Frontend
    return (
        <div>

            <Topnav />
            <ListeDeProjets />
            <Footer />
        </div>
    )
}

//Export du composant
export default Projets;
